import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
 afterNextRender,
 Component,
 computed,
 DestroyRef,
 effect,
 ElementRef,
 EventEmitter,
 HostListener,
 Inject,
 inject,
 OnInit,
 Output,
 PLATFORM_ID,
 Renderer2,
 Signal,
 signal,
 ViewChild,
 WritableSignal,
} from '@angular/core';
import { MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterModel } from '@core/models/domains/filters.model';
import { SearchResponse, SearchResultFaq } from '@core/models/domains/hotel';
import { SearchResultHotelsCard } from '@core/models/DTOs/hotel.dto';
import { GetUserProfileResponse } from '@core/models/DTOs/userProfile.dto';
import { AuthService } from '@core/services/authentication/auth.service';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { ModalService } from '@shared/services/modal.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import {
 Subject,
 BehaviorSubject,
 Subscription,
 throttleTime,
 distinctUntilChanged,
 skip,
 fromEvent,
 takeUntil,
 tap,
 map,
 combineLatest,
} from 'rxjs';
import { SearchResultUiService } from '../../pages/search-result/services/search-result-ui.service';
import { MomentService } from '@core/services/moment.service';
import { WebengageService } from '@core/services/webengage.service';
import { LoadingService } from '@shared/services/loading.service';
import { WINDOW } from '../../app.module';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DatepickerService } from '@shared/services/datepicker.service';
import { RialToTomanPipe } from '@shared/pipes/rial-to-toman.pipe';

@Component({
 template: ``,
})
export class SearchResultBaseClass implements OnInit {
 constructor(
  @Inject(WINDOW) public window: Window,
  @Inject(DOCUMENT) public document: Document,
  @Inject(PLATFORM_ID) public platformId: Object, // Corrected type here
  public loadingService: LoadingService,
  public webEngageService: WebengageService,
  public momentService: MomentService,
   public RialToTomanPipe: RialToTomanPipe
 ) {
  afterNextRender(() => {
   this.loadingService.resetRefreshModalTimer('plp');

   if (this.navigatorVall) {
    const rayachatNode = document.getElementById('raychat_widget') as HTMLElement;
    if (rayachatNode) rayachatNode.style.transition = '0.3s ease-in-out all';
    if (rayachatNode) rayachatNode.style.bottom = '0px';
   }
 //  history.pushState(null, '', this.window.location.href);
   this.heightOfEachCard = this.navigatorVal ? 260 : 400;
   this.heightOfEachPage =
    this.heightOfEachCard * this.searchUiService.pageSize +
    16 * (this.searchUiService.pageSize - 1);
   this.initialWrapperTop =
    this.initialWrapperTop === 0
     ? this.scrollableSection.nativeElement.getBoundingClientRect().top
     : this.initialWrapperTop;
  // this.handleBackAction();

   this.watchScrollChanges();
  });
   

  effect(() => {
   this.userData = this.authService.getUserData();
  });
   effect(() => {   
     const searchResult = this.searchUiService.searchResult();
     const filters = searchResult?.FilterBar || [];
     if (!filters.length) return;
     const params = this.route.snapshot.queryParams;
     this.checkSelectedFilter(params);
   });

  if (isPlatformBrowser(this.platformId))
   this.navigatorVal = !/Android|iPhone/.test(this.window.navigator.userAgent);
 }

 @ViewChild('sort') sortTemplate!: any;
 @ViewChild('Range') rangeTemplate!: any;
 @ViewChild('Residence') residenceTemplate!: any;
 scrollMode: '' | 'scrollDown' | 'scrollUp' = '';
 typesFilters = '';
 drawerIsOpenFilters = false;
 @Output() toggleDrawerFilters = new EventEmitter(this.drawerIsOpenFilters);
 showHeaderSearch = false;
 @ViewChild('cardsWrapper', { static: true }) scrollableSection!: ElementRef;
 @ViewChild('plpfaq', { static: true }) plpfaq!: any;
 searchUiService = inject(SearchResultUiService);
 route = inject(ActivatedRoute);
 router = inject(Router);
 modalService = inject(ModalService);
 dialog = inject(MatDialog);
 renderer = inject(Renderer2);
 _bottomSheet = inject(MatBottomSheet);
 searchSRVC = inject(SearchBoxService);
 authService = inject(AuthService);
 autoCompleteService = inject(AutocompleteService);
 datepickerService = inject(DatepickerService);
 destroyRef = inject(DestroyRef);
 isDatepickerOpen = computed(() => this.datepickerService._state());
  selectedFilterTitles: any;
 searchResultSignal: WritableSignal<SearchResponse | undefined> = signal(undefined);
 currentPageIndex = 0;
 navigatorVal = true;
 rangeItems: any;
 residenceItems: any;
 searchResult?: SearchResponse;
 cards?: SearchResultHotelsCard[];
 faqs: SearchResultFaq[] = [];
 searchLoading = false;
 queryParams: Record<string, string> = {};
 accommodationState: Signal<string> = computed(() => this.searchSRVC.accommodation());
 userData!: WritableSignal<GetUserProfileResponse>;

 scrollEvent$ = new Subject<number>();
 indexOfCurrentPageInArray = new BehaviorSubject<number>(0);
 lastFiltersCount = 0;
 hasPrevPage = false;
 hasNextPage = false;
 plpRelatedLinks: any = {};
 lastScrollYPosition = 0;
 scrollableSectionTopPosition = 0;
 heightOfWholePage = 0;
 // scrollToBottom = 2000 // remaining space to bottom of the page
 heightOfEachCard = 0;
 heightOfEachPage = 0;
 nextPageLoading = false;
 prevPageLoading = false;
 fetchedPages: Array<number> = [];
 initialWrapperTop = 0; // could be mobile:222 and desktop:250
 // dynamicContentHeight = 50 //height of FAQ content

 previousHashKey = ''; // we use it to determine filter bar's data should rerender or not

 minPriceValue = 0;
 filtersData: FilterModel[] = [];
 maxPriceValue = 0;
 _minValue = 0;
 _maxValue = 0;
 showPriceFilter = signal(true);
 showSideFilter = signal(true);
 navigatorVall: any = isPlatformBrowser(this.platformId)
  ? /Android|iPhone/.test(this.window.navigator.userAgent)
  : undefined;

 modalTimerSub?: Subscription;

 destroy$ = new Subject();

 ngOnInit(): void {
  // برای زمانی که ما دیتای یک صفحه رو قبلا گرفتیم و کاربر درحال اسکرول روی همون صفحاته
  // برای اینکه تشخیص بدیم که موقعیت اسکرول فعلی کدوم صفحه است !
  // روت رو عوض میکنیم ولی با کمک کش سرویسمون ریکوئست تکراری نمیزنیم
  if (this.accommodationState() !== 'ecolodge') {
    this.indexOfCurrentPageInArray
     .pipe(distinctUntilChanged(), skip(1), takeUntilDestroyed(this.destroyRef))
     .subscribe((index: number) => {
      this.currentPageIndex = this.searchUiService.fetchedPages[index] ?? this.currentPageIndex;
      this.getAnotherPage();
     });
  }
  
 }

 // handled ecolodge active filters
  checkSelectedFilter(params: any): void {
    const result: Record<string, string[]> = {};

    let minPrice = params['minPrice'] ? this.RialToTomanPipe.transform(+params['minPrice']) : '';
    let maxPrice = params['maxPrice'] ? this.RialToTomanPipe.transform(+params['maxPrice']) : '';
    let priceTitle = '';
    if (minPrice && maxPrice) {
      priceTitle = `از ${+minPrice > 1000000 ?
         (+minPrice / 1000000) + 'میلیون ' : +minPrice + ' تومان '} تا ${+maxPrice > 1000000 ? (+maxPrice / 1000000) + ' میلیون ' :
        +maxPrice + ' تومان '}`;
    } else if (minPrice) {
      priceTitle = `از ${+minPrice > 1000000 ? (+minPrice / 1000000) + ' میلیون ' :
         +minPrice + ' تومان '} `; 
    } else if (maxPrice) {
      priceTitle = `تا ${+maxPrice > 1000000 ? (+maxPrice / 1000000) + ' میلیون ' :
         +minPrice + ' تومان '}`;
    }

    if (priceTitle) {
      result['price'] = [priceTitle];
    }
    Object.entries(params).forEach(([key, value]) => {
      if (key === 'minPrice' || key === 'maxPrice') return;

      const selectedValues = String(value).split(",");
      const selectedTitles: string[] = [];

      const filter = this.filtersData.find(f => f.Key === key);
      if (!filter) return;

      selectedValues.forEach(val => {
        const item = filter.Items.find(i => i.Value === val);
        if (item && item.Title) {
          selectedTitles.push(item.Title);
        }
      });

      if (selectedTitles.length > 0) {
        result[key] = selectedTitles;
      }
    });
    this.selectedFilterTitles = Object.entries(result).map(([key, value]) => ({
      key,
      Title: value[0],
      count: [...new Set(value)].length
    }));
  }

 watchScrollChanges() {
  this.scrollEvent$.pipe(throttleTime(20)).subscribe(() => {
   const heightOfScrollable = this.scrollableSection.nativeElement.scrollHeight;
   const currentScrollYPosition = this.window.scrollY;
   const innerHeight = this.window.innerHeight;

   // const spaceOfElementAndPage = this.heightOfWholePage - heightOfScrollable
   // this.scrollToBottom = heightOfScrollable - innerHeight - currentScrollYPosition + spaceOfElementAndPage

   const scrollingUp =
    this.lastScrollYPosition > this.scrollableSectionTopPosition &&
    this.lastScrollYPosition > currentScrollYPosition;

   if (this.hotelsAreNotVisible(this.scrollableSection.nativeElement)) return;
   else {
    this.lastScrollYPosition = currentScrollYPosition;

    if (
     this.hasNextPage &&
     !this.searchUiService.nextPageLoading() &&
     currentScrollYPosition + innerHeight > heightOfScrollable &&
     !this.searchUiService.showPagination()
    )
     this.getNextPage();
    else if (
     this.hasPrevPage &&
     !this.searchUiService.prevPageLoading() &&
     currentScrollYPosition < 600 &&
     scrollingUp &&
     this.accommodationState() !== 'ecolodge'
    )
     this.getPrevPage();

    if (this.hotelsAreNotVisible(this.scrollableSection.nativeElement)) return;
    else {
     const pageNumberVisibleOnViewPort = Math.floor(currentScrollYPosition / this.heightOfEachPage);
     // if(pageNumberVisibleOnViewPort > 0)
     this.indexOfCurrentPageInArray.next(pageNumberVisibleOnViewPort);
    }
   }
  });
 }

 getNextPage() {
  if (!this.searchUiService.showPagination()) {
    this.queryParams = this.route.snapshot.queryParams;
    this.searchUiService.nextPageLoading.set(true);
    this.currentPageIndex = this.searchUiService.fetchedPages[this.searchUiService.fetchedPages.length - 1] + 1;
    
    this.getAnotherPage();
  }
 }


 getPrevPage() {
  this.queryParams = this.route.snapshot.queryParams;
  this.searchUiService.prevPageLoading.set(true);
  this.currentPageIndex = this.searchUiService.fetchedPages[0] - 1;

  this.getAnotherPage();
 }

 // isInViewPort(scrollY: number, innerHeight: number, wholeHeight: number) {
 hotelsAreNotVisible(element: HTMLElement) {
  const rect = element.getBoundingClientRect();
  return (
   (rect.bottom < 300 && rect.top < 0) || //کاربر از سکشن اتاق ها گذشته است
   (rect.bottom > 1000 && rect.top > -200) // کاربر در ابتدای صفحه است و هنوز اسکرول را شروع نکرده است
  );
 }

 @HostListener('window:scroll', ['$event.target'])
 windowScrollEvent(e: Event) {
  if (isPlatformBrowser(this.platformId)) {
   this.scrollEvent$.next(this.window.scrollY);
  }
 }

 getAnotherPage() {
  
  
  if (this.searchUiService.lastUsedPayload.isFirstRequest) {
   this.currentPageIndex = 1;
   (this.searchUiService.pageIndex = 1), (this.searchUiService.fetchedPages = []);
  } else {
    if (this.accommodationState() === 'ecolodge') {
      this.searchUiService.pageIndex = this.searchUiService.pageIndex + 1
    }
  }

  if (!this.nextPageLoading && !this.prevPageLoading) {
   if (!this.searchUiService.fetchedPages.includes(this.currentPageIndex)) {
    if (this.accommodationState() === 'ecolodge') {
      this.router.navigate([], {
        queryParams: {
         ...this.queryParams
        },
        queryParamsHandling: 'merge',
        relativeTo: this.route,
       });
      //  this.currentPageIndex =
      
    } else {
      this.router.navigate([], {
       queryParams: {
        ...this.queryParams,
        page: isNaN(+this.queryParams['page'] + 1) ? 2 : this.currentPageIndex + 1,
       },
       queryParamsHandling: 'merge',
       relativeTo: this.route,
      });
    }
   }
  }
 }

 openSortTemplate(config?: MatBottomSheetConfig) {
  this._bottomSheet.open(this.sortTemplate, config);
 }

 showFilters() {
  this.searchSRVC.showFiltersSideNav.set(true);
  const scrollTop = this.window.pageYOffset || document.documentElement.scrollTop;
  const scrollLeft = this.window.pageXOffset || document.documentElement.scrollLeft;
  this.window.onscroll = function () {
   window.scrollTo(scrollLeft, scrollTop);
  };
 }

 closeSort(ev: any) {
  this._bottomSheet.dismiss();
 }

 handleBackAction() {
  fromEvent(window, 'popstate')
   .pipe(
    tap(() => history.pushState(null, '')),
    takeUntil(this.destroy$)
   )
   .subscribe((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.navigatorVall) {
     const rayachatNode = document?.getElementById('raychat_widget') as HTMLElement;
     if (rayachatNode) rayachatNode.style.bottom = '60px';
    }
     if (isPlatformBrowser(this.platformId)) {
    setTimeout(() => {
     this.router
      .navigate([this.searchSRVC.accommodation() == 'ecolodge' ? '/ecolodge' : '/'])
      .finally(() => this.window.scrollTo({ top: 0, behavior: 'instant' }));
    }, 200);
  }
   });
 }

 ngOnDestroy(): void {
  this.destroy$.next('');
  this.destroy$.complete();
  this.searchUiService.showPagination.set(false)
  this.loadingService.modalTimerSub?.unsubscribe();
 }
}
